import React from "react";
import "./Terms_Conditions_content.css";

function Terms_Conditions_content() {
  return (
    <>
      <section className="Terms_Conditions_content_holder">
        <div className="container">
          <div className="Terms_Conditions_content">
            <div className="text_holder">
              <h4>Terms & Conditions</h4>
              <p>By using the Profcyma Finance website and availing our personal loan services in India, you
                agree to these terms:</p>
            </div>

            <div className="text_holder">
              <h4>1.Eligibility</h4>
              <ul>
                <li>You must be at least 18 years old, an Indian resident, and legally capable of entering
                  into contracts under the Indian Contract Act, 1872.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>2.Loan Application</h4>
              <ul>
                <li>You certify that all information provided in your application is accurate and truthful.</li>
                <li>Providing false or misleading information may result in rejection or legal action.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>3.Loan Terms</h4>
              <ul>
                <li>Loan terms, including eligibility, interest rates, processing fees, tenure, and
                  repayment schedules, will be disclosed prior to approval and acceptance.</li>
                <li>All loans are subject to credit approval under applicable Indian laws and RBI
                  guidelines.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>4.Responsible Lending</h4>
              <ul>
                <li>We are committed to responsible lending and full compliance with RBI guidelines, fair
                  lending practices, anti-money laundering (AML) and KYC norms.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>5.Website Use</h4>
              <ul>
                <li>You commit not to use the site for unlawful purposes.</li>
                <li>Content on this site may not be copied, distributed, or exploited without our
                  permission.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>6.Disclaimers</h4>
              <ul>
                <li>Loan approval is subject to internal checks and credit assessment.</li>
                <li>Profcyma Finance is not responsible for any losses arising from use of third-party
                  services or links.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>7.Limitation of Liability</h4>
              <ul>
                <li>Profcyma Finance is not liable for any indirect or incidental damages related to your
                  use of our services or website, to the extent permitted under Indian law.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>8.Google Advertising Policy Compliance</h4>
              <ul>
                <li>We adhere to Google Ads policies, including:</li>
                <li>Full, clear disclosure of loan product features, eligibility, applicable interest
                  rates, fees/charges, and terms.</li>
                <li>No misleading or deceptive claims.</li>
                <li>No targeting minors.</li>
                <li>No loans disbursed at rates above RBI’s stipulated maximum interest rate
                  guidelines.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>9. Grievance and Redressal</h4>
              <ul>
                <li>You may contact our Grievance Officer at [1800-267-8961 / +91 96077 55557] for any complaints or disputes.</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>10.Governing Law and Jurisdiction</h4>
              <ul>
                <li>These terms will be governed by the laws of India.</li>
                <li>Any disputes shall be subject to the exclusive jurisdiction of the courts in [Pune,Maharashtra].</li>
              </ul>
            </div>

            <div className="text_holder">
              <h4>8.Contact Us</h4>
              <ul>
                <li>For any privacy concerns or to exercise your data rights, contact us at: [1800-267-8961 / +91 96077 55557].</li>
              </ul>
            </div>



          </div>
        </div>
      </section>
    </>
  );
}

export default Terms_Conditions_content;
